var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"podcasts-content"},_vm._l((_vm.podcasts),function(p){return _c('b-row',{key:p.key,staticClass:"podcast-row"},[_c('b-col',[_c('iframe',{attrs:{"width":"100%","height":"120","src":_vm.getPodcastSrc(p),"frameborder":"0"}})])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f06f566","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Podcasts.vue
// module id = 393
// module chunks = 0